import { ROUTES } from '@/routes/routes'
import { isCitationUuid } from './injectCitationMarkers'

/** Resolve identity through the document API; never derive it from report text. */
export async function studyCitationTarget(
  documentToken: string | null | undefined,
  readDocument: (token: string) => Promise<{ sourceStudyId?: string | null }>,
): Promise<string> {
  if (!documentToken || !isCitationUuid(documentToken)) {
    throw new Error('Study citation has no public document token')
  }
  const document = await readDocument(documentToken)
  return studyResultsTarget(document.sourceStudyId)
}

/** The study results route for a public study token (`experiments.token`); never a row id. */
export function studyResultsTarget(studyToken: string | null | undefined): string {
  if (!studyToken || !isCitationUuid(studyToken)) {
    throw new Error('Study citation has no public study reference')
  }
  return ROUTES.studyResults(studyToken.trim())
}
